import { render, staticRenderFns } from "./OrderConfirmDialog.vue?vue&type=template&id=a96813ca&scoped=true"
import script from "./OrderConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./OrderConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./OrderConfirmDialog.vue?vue&type=style&index=0&id=a96813ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96813ca",
  null
  
)

export default component.exports